import NewImage from '@global/components/global/image';
import AlertDialog from '@global/helpers/alertDialog';
import ITEM_TMPL from '@page/favorite/js/itemTmpl';
import TABLE_TMPL from '@page/favorite/js/tableTmpl';
import APP_TMPL from '@page/favorite/js/appTmpl';
import axios from 'axios';
import Pagination from '@global/components/global/Pagination';

const favoriteItem = {
  template: ITEM_TMPL,
  props: ['data', 'idx'],
  components: {
    NewImage,
  },
  data: function () {
    return {
      productName: this.data.Name,
      productImg: this.data.Colors[0].Covers[0],
      productLink: this.data.Colors[0].MarketUrl,
      originPrice: this.data.OriginPrice,
      sellPrice: this.data.SellPrice,
      eventPrice: this.data.EventPrice,
    };
  },
  methods: {
    cancelFavorite(elCustomMarketID) {
      axios
        .delete(API_URL.FAVORITE, {
          data: {
            CustomMarketID: elCustomMarketID,
          },
        })
        .then((res) => {
          if (res.data.Code === 200) {
            if (res.data.Response) {
              this.$emit('delete');
            }
          } else if (res.data.Code === 401) {
            AlertDialog.alert('請先登入');
          } else {
            AlertDialog.alert('系統忙線中');
          }
        })
        .catch((error) => {
          AlertDialog.alert(error);
        });
    },
  },
};

const favoriteTable = {
  template: TABLE_TMPL,
  props: ['data'],
  components: {
    favoriteItem,
  },
  methods: {
    cancelFavorite: function (index) {
      this.$emit('delete', index);
    },
  },
};

const favoriteApp = {
  template: APP_TMPL,
  components: {
    favoriteTable,
    Pagination,
  },
  data: function () {
    return {
      dataIsLoad: false,
      nowPage: 1,
      data: [],
      noItems: false,
      totalPage: null,
      arrayCount: 0,
      totalCount: 0,
    };
  },
  props: [],
  created: function () {
    this.fetchItems();
  },
  mounted: function () {},
  methods: {
    cancelFavorite: function (index) {
      this.data.splice(index, 1);
    },
    fetchItems: function () {
      const nowLocation = window.location.toString();

      if (nowLocation.indexOf('?') !== -1) {
        const args = nowLocation.split('?')[1].split('&');
        for (let i = 0; i < args.length; i++) {
          if (args[i].indexOf('P=') !== -1) {
            this.nowPage = parseInt(args[i].replace('P=', ''));
          }
        }
      } else {
        this.nowPage = 1;
      }

      axios
        .get(API_URL.FAVORITE, {
          params: {
            Page: this.nowPage,
            PageSize: 20,
          },
        })
        .then((res) => {
          if (res.data.Code === 200) {
            this.dataIsLoad = true;
            this.totalPage = res.data.Response.PageCount;
            this.totalCount = res.data.Response.TotalCount;
            this.data = res.data.Response.Data;
          }
        })
        .catch((error) => {
          AlertDialog.alert(error);
        });
    },
  },
  beforeDestroy: function () {},
};

export default favoriteApp;
